function setupProductPage() {
  if (jQuery('section > div').hasClass('products')) {
    intializeAddToFavoritesCookies()
    loadFavorites()
    setupAddToFavorites()
    floatProductSideBarOnScroll()
  }

  if (
    jQuery('section > div').hasClass('products') &&
    !jQuery('.products').hasClass('detail')
  ) {
    setupProductInfiniteScroll()
    setupProductCheckMarks()
    checkIfImageExists('.product-gallery-img', '728x486')
    setupProductSearchBox()
    loadProductFilterValues()
    productFilter()
  }

  if (
    jQuery('section > div').hasClass('products') &&
    jQuery('.products').hasClass('detail')
  ) {
    setupIntensityDetails()
  }

  jQuery('.product-video-carousel').owlCarousel({
    navigation: true,
    navigationText: [
      "<i class='fa fa-angle-left'></i>",
      "<i class='fa fa-angle-right'></i>"
    ],
    pagination: true,
    slideSpeed: 300,
    paginationSpeed: 400,
    singleItem: true
  })

  jQuery('.product-carousel').owlCarousel({
    navigation: true,
    navigationText: [
      "<img src='/img/icons/slider-arrow-left.png'/>",
      "<img src='/img/icons/slider-arrow-right.png'/>"
    ],
    pagination: true,
    slideSpeed: 300,
    paginationSpeed: 400,
    singleItem: true,
    afterInit: function (el) {
      el.find('.owl-pagination').addClass('hidden-xs')
    }
  })

  jQuery('.other-product-carousel').owlCarousel({
    navigation: true,
    navigationText: [
      "<i class='fa fa-angle-left'></i>",
      "<i class='fa fa-angle-right'></i>"
    ],
    pagination: true,
    slideSpeed: 300,
    paginationSpeed: 400,
    singleItem: false
  })

  jQuery('a.product-educational-videos').colorbox({
    html: "<div class='embed-responsive embed-responsive-16by9'><iframe id='colorbox-youtube' class='embed-responsive-item' src='' frameborder='0' allowfullscreen></iframe></div>",
    maxWidth: '80%',
    maxHeight: '90%',
    width: '90%',
    onComplete: function () {
      jQuery('#colorbox-youtube').attr(
        'src',
        'https://www.youtube.com/embed/' +
          jQuery(this).attr('embeded-code') +
          '?rel=0'
      )
      jQuery.colorbox.resize()
    }
  })

  jQuery('#learn-how-resources').colorbox({
    inline: true,
    href: '#templates #product-videos',
    maxWidth: '80%',
    maxHeight: '90%',
    closeButton: false,
    width: '90%',
    onComplete: function () {
      jQuery('#colorbox-youtube').attr(
        'src',
        'https://www.youtube.com/embed/' +
          jQuery(this).attr('embeded-code') +
          '?rel=0'
      )
      jQuery.colorbox.resize()
    }
  })

  jQuery('.products .compare-favorites').colorbox({
    inline: true,
    href: '#templates #compare-products',
    maxWidth: '80%',
    maxHeight: '90%',
    closeButton: false,
    width: '90%',
    onLoad: function () {
      jQuery('#templates #compare-products #close').click(function (e) {
        e.preventDefault()
        jQuery.colorbox.close()
      })
    },
    onComplete: function () {
      jQuery.colorbox.resize()
    }
  })

  jQuery('.carousel-item .credit a').click(function (e) {
    clearTimeout(colorboxDelay)
  })
}

var productGalleryPage = 1
var productGalleryLastPage = false
var productInfiniteInprogress = false
var productLoadMoreTimeout = null
var favorites = []
var galleryFilter = {}

function floatProductSideBarOnScroll() {
  var explicitlySetAffixPosition = function () {}

  //Safari Bug.
  if (
    navigator.userAgent.indexOf('Safari') != -1 &&
    navigator.userAgent.indexOf('Chrome') == -1
  ) {
    var explicitlySetAffixPosition = function () {
      $('.products #sidebar').css(
        'left',
        $('.products #sidebar').parent().offset().left + 10 + 'px'
      )
    }
  }

  $('.products #sidebar')
    .affix({
      offset: {
        top: 749, //357
        bottom: function () {
          //console.log(jQuery('footer').outerHeight(true));
          return (this.bottom = jQuery('footer').outerHeight(true) - 20)
        }
      }
    })
    .on('affixed.bs.affix', function () {
      explicitlySetAffixPosition()
      if (jQuery(window).innerHeight() < 900) {
        jQuery('.favorites').slideUp(function () {
          jQuery(this)
            .parent()
            .find('a.visible-xs')
            .first()
            .addClass('visible-lg')
            .addClass('visible-md')
            .addClass('visible-sm')
        })
      }
    })
    .on('affixed-bottom.bs.affix', function () {
      jQuery(this).css('position', 'fixed')
    })
    .on('affixed-top.bs.affix', function () {
      jQuery(this).css('position', '')
    })
}

function intializeAddToFavoritesCookies() {
  try {
    if (jQuery.cookie) jQuery.cookie.json = true
    favorites = jQuery.cookie('favorites') ? jQuery.cookie('favorites') : []
    var emptyFilter = {
      productLine: '',
      watercolor: '',
      finishType: '',
      search: ''
    }

    var galleryFilterCookie = jQuery.cookie('galleryFilter')

    if (jQuery('#productLine').val() && galleryFilterCookie)
      galleryFilterCookie.productLine = jQuery('#productLine').val()

    if (jQuery('#productLine').val() && !galleryFilterCookie)
      emptyFilter.productLine = jQuery('#productLine').val()

    galleryFilter = galleryFilterCookie ? galleryFilterCookie : emptyFilter
    galleryFilter.search = ''
  } catch (e) {
    console.error(e)
  }
}

function setupRemoveFromFavorites() {
  jQuery('.remove-from-favorites')
    .unbind()
    .click(function (e) {
      e.preventDefault()
      var uuid = jQuery(this).attr('product-uuid')
      jQuery.each(favorites, function (index, favorite) {
        if (favorite && favorite.uuid == uuid) {
          favorites.splice(index, 1)
        }
      })

      jQuery.cookie('favorites', favorites, { expires: 30, path: '/' })
      loadFavorites()
    })
}

function setupAddToFavorites() {
  jQuery('.add-to-favorites')
    .unbind()
    .click(function (e) {
      e.preventDefault()

      var uuid = jQuery(this).attr('product-uuid')

      if (!uuid) return

      var alreadyAdded = false
      jQuery.each(favorites, function (i, favorite) {
        if (favorite.uuid == uuid) {
          alreadyAdded = true
          return
        }
      })

      if (alreadyAdded) return

      var button = jQuery(this)

      jQuery
        .get('/products/product/' + uuid, function (product) {
          favorites.push({
            uuid: uuid,
            title: product.title,
            galleryImageUrl: product.galleryImageUrl,
            finishImageUrl: product.productFinishImage,
            productLineUrl: product.productLineImage,
            WatercolorImageUrl: product.productWatercolorImage,
            waterIntensityImageUrl: product.productWaterIntensityImage,
            slug: product.url
          })

          jQuery.cookie('favorites', favorites, { expires: 30, path: '/' })
          jQuery(button).addClass('favorited')
          jQuery(button).find('#favorites-text').html('Favorited')
          loadFavorites()
        })
        .fail(function () {
          alert('error')
        })
    })
}

function loadFavorites() {
  const path = window.location.pathname

  jQuery('.favorites .list').html('')
  jQuery('.products.compare .list').html('')

  jQuery('.add-to-favorites.favorited #favorites-text').html('Add to Favorites')
  jQuery('.add-to-favorites.favorited').removeClass('favorited')

  if (favorites.length <= 0) {
    jQuery('.favorites .list').append(
      "<p class='text-center small'>You have no favorites.</p>"
    )
    jQuery('.products.compare .list').append(
      "<p class='text-center'>You have no favorites.</p>"
    )
    return
  }

  var uuids = ''
  var shareText = ''
  jQuery.each(favorites, function (i, favorite) {
    var template =
      "<div class='col-xs-3 col-sm-4 col-lg-3 padding-xs'><a href='" +
      favorite.slug +
      "' title='" +
      favorite.title +
      "'><img class='img-responsive thumbnail padding-xxs margin-bottom-none' src='" +
      favorite.finishImageUrl +
      "'></a></div>"
    jQuery('.favorites .list').append(template)

    uuids += favorite.uuid + ','

    jQuery('.favorites a').tooltip({
      position: {
        my: 'center bottom-20',
        at: 'center top',
        using: function (position, feedback) {
          $(this).css(position)
          $('<div>')
            .addClass('arrow')
            .addClass(feedback.vertical)
            .addClass(feedback.horizontal)
            .appendTo(this)
        }
      }
    })

    template = jQuery('#templates #compare-product').clone()
    shareText += favorite.title.trim() + ', '
    jQuery(template).find('#title').html(favorite.title)
    jQuery(template).find('img#gallery').attr('src', favorite.galleryImageUrl)
    jQuery(template)
      .find('img#product-line')
      .attr('src', favorite.productLineUrl)
    jQuery(template).find('img#finish').attr('src', favorite.finishImageUrl)
    jQuery(template)
      .find('img#watercolor')
      .attr('src', favorite.WatercolorImageUrl)
    jQuery(template)
      .find('img#water-intensity')
      .attr('src', favorite.waterIntensityImageUrl)
    jQuery(template)
      .find('#go-to-products')
      .attr('href', `${path}/${favorite.slug}`)
    jQuery(template)
      .find('.remove-from-favorites')
      .attr('product-uuid', favorite.uuid)

    jQuery('.products.compare .list').append(template.html())

    jQuery(".add-to-favorites[product-uuid='" + favorite.uuid + "']").addClass(
      'favorited'
    )
    jQuery(
      ".add-to-favorites[product-uuid='" + favorite.uuid + "'] #favorites-text"
    ).html('Favorited')
  })

  jQuery('.products.compare .social-share').html('')

  var shareUrl = '/products/compare?uuids=' + escape(uuids)
  var socialShareTemplate =
    '<div class="separator-xs visible-xs visible-sm"></div><span class=""><small>Share your favorites :</small> </span><span id="facebookLikeContainer"><div class="fb-share-button" data-href="' +
    shareUrl +
    '" data-layout="button"></div></span><span id="plusOneContainer"><div  class="g-plus"></div></span><a href="https://twitter.com/share" class="twitter-share-button" data-text="Wet Edge | Comparing | ' +
    shareText +
    '" data-url="http://www.wetedgetechnologies.com' +
    shareUrl +
    '" data-count="none">Tweet</a><a href="#" id="share-by-email" class="btn btn-default btn-xs btn-primary">Email</a><button type="button" id="get-link" class="btn btn-default btn-xs btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">Get Link</button><div class="dropdown-menu padding-sm form-horizontal" style="min-width:350px" role="menu"><div class="form-group margin-bottom-none"><label class="control-label col-sm-2">Copy</label><div class="col-sm-10"><input type="text" class="form-control" value="http://www.wetedgetechnologies.com' +
    shareUrl +
    '"/></div></div></div>'

  jQuery('.products.compare .social-share').append(socialShareTemplate)

  var shareEmailBody =
    'My Favorite Products at Wet Edge \n http://www.wetedgetechnologies.com' +
    shareUrl
  jQuery('.products.compare #share-by-email').attr(
    'href',
    'mailto:your@email.com?body=' + encodeURIComponent(shareEmailBody)
  )
  jQuery('.products.compare #get-link').click(function () {
    jQuery('.products.compare .dropdown-menu').toggle()
  })

  window.twttr.ready(function (twttr) {
    twttr.widgets.load()
  })

  try {
    FB.XFBML.parse()
  } catch (ex) {}

  try {
    gapi.plusone.render('plusOneContainer', {
      href: 'http://www.wetedgetechnologies.com' + shareUrl,
      annotation: 'none',
      size: 'medium'
    })
  } catch (ex) {}

  setupRemoveFromFavorites()
}

function setupIntensityDetails() {
  jQuery('.products .view-intensity').colorbox({
    inline: true,
    href: '#templates #intensity-details',
    maxWidth: '650px',
    maxHeight: '90%',
    closeButton: false,
    width: '90%',
    height: '90%',
    onLoad: function () {
      jQuery('.products.intensity-details #close').click(function (e) {
        e.preventDefault()
        jQuery.colorbox.close()
      })

      var uuid = jQuery(this).attr('product-uuid')

      jQuery
        .get('/products/product/' + uuid, function (product) {
          jQuery('.products.intensity-details #title').html(
            product.title + ' - ' + product.WaterIntensity.name
          )
          jQuery(
            '.products.intensity-details #product-water-intensity-img'
          ).attr('src', product.productWaterIntensityImage)
          jQuery('.products.intensity-details #product-primary-img').attr(
            'src',
            product.galleryImageUrl
          )
          jQuery('.products.intensity-details #intensity-description').html(
            product.WaterIntensity.WaterColor.description
          )
          jQuery.colorbox.resize()
        })
        .fail(function () {
          alert('error')
        })
    },
    onComplete: function () {
      jQuery.colorbox.resize()
    }
  })
}

function setupProductSearchBox() {
  jQuery('.products #search').click(function (e) {
    e.preventDefault()
    galleryFilter.search = jQuery('.products #search-text').val()
    productFilter()
  })
}

function setupProductCheckMarks() {
  jQuery('.products  .check-mark')
    .unbind()
    .click(function (e) {
      e.preventDefault()

      if (jQuery(this).hasClass('checked')) jQuery(this).removeClass('checked')
      else jQuery(this).addClass('checked')

      productFilter()
    })
}

function setupProductInfiniteScroll() {
  jQuery(window).scroll(function () {
    if (
      jQuery(window).scrollTop() + jQuery(window).height() >
      jQuery(document).height() - 100
    ) {
      loadMoreProducts()
    }
  })
}

function showNoMoreProducts() {
  jQuery('.products #no-more-results').show()
  jQuery('.products #keep-scrolling').hide()
}

function loadMoreProducts() {
  jQuery('.products #no-more-results').hide()

  if (productInfiniteInprogress) return

  if (productGalleryLastPage) {
    showNoMoreProducts()
    return
  }

  jQuery('.products #loading').show()
  jQuery('.products #no-more-results').hide()

  productLoadMoreTimeout = setTimeout(function () {
    productInfiniteInprogress = true
    productGalleryPage++
    var parameters =
      '&productLine=' +
      galleryFilter.productLine +
      '&watercolor=' +
      galleryFilter.watercolor +
      '&finishType=' +
      galleryFilter.finishType +
      '&search=' +
      galleryFilter.search
    jQuery
      .get(
        '/products/list?limit=9&page=' + productGalleryPage + parameters,
        function (data) {
          if (data.length > 0) {
            jQuery.each(data, function (index, product) {
              appendProductToGallery(product)
            })

            productInfiniteInprogress = false
          } else {
            productGalleryLastPage = true
            productInfiniteInprogress = false
            showNoMoreProducts()
          }
        }
      )
      .always(function () {
        setupAddToFavorites()
        loadFavorites()
        jQuery('.products #loading').hide()
      })
  }, 200)
}

function appendProductToGallery(product) {
  const template = jQuery('#templates #product').clone()
  let description = product.description
  const path =
    window.location.pathname === '/satin-matrix'
      ? '/products'
      : window.location.pathname

  if (description.length > 88)
    description = description.substring(0, 88) + ' ...'

  jQuery(template).find('.title h2').html(product.title)

  if (product.is_new)
    jQuery(template).find('a#url .badge').removeClass('hidden')

  if (product.title.length > 19)
    jQuery(template).find('.title h2').css('font-size', '22px')

  jQuery(template)
    .find('#description')
    .html(description.replace(/<[^>]+>/g, ''))
  jQuery(template).find('.title a').attr('href', `${path}/${product.url}`)
  jQuery(template).find('a#url').attr('href', `${path}/${product.url}`)
  jQuery(template).find('a.learn-more').attr('href', `${path}/${product.url}`)

  jQuery
    .get(product.galleryImageUrl, null, function (data) {
      jQuery(template).find('a#url img').attr('src', product.galleryImageUrl)
      jQuery(template).find('a#url img').attr('alt', product.galleryImageAlt)
    })
    .fail(function (XMLHttpRequest, textStatus, errorThrown) {
      jQuery(template)
        .find('a#url img')
        .attr('src', 'http://placehold.it/728x486')
    })

  jQuery(template)
    .find('#product-finish-img')
    .attr('src', product.productFinishImage)
  jQuery(template)
    .find('#product-finish-img')
    .attr('alt', product.galleryImageAlt + '-' + 'finish')
  jQuery(template)
    .find('#product-watercolor-img')
    .attr('src', product.productWatercolorImage)
  jQuery(template)
    .find('#product-watercolor-img')
    .attr('alt', product.productWatercolorImageAlt)
  jQuery(template)
    .find('#product-line-img')
    .attr('src', product.productLineImage)
  jQuery(template)
    .find('#product-line-img')
    .attr('alt', product.productLineImageAlt)
  jQuery(template)
    .find('#product-water-intensity-img')
    .attr('src', product.productWaterIntensityImage)
  jQuery(template).find('#add-to-favorites').attr('product-uuid', product.uuid)

  jQuery('.products .grid').append(template)
}

function filterByProductLine(e, productLineId) {
  e.preventDefault()
  galleryFilter.productLine = '' + productLineId + ''
  galleryFilter.watercolor = ''
  galleryFilter.finishType = ''
  galleryFilter.search = ''

  loadProductFilterValues()
  productFilter()
  jQuery('html, body').animate(
    { scrollTop: jQuery('.grid').offset().top - 70 },
    800
  )
}

function loadProductFilterValues() {
  if (galleryFilter.productLine) {
    jQuery('.products .filter .product-lines > li a').each(function (index) {
      jQuery(this).removeClass('checked')
      var id = jQuery(this).attr('id')
      var productLines = galleryFilter.productLine.split(',')

      if (jQuery.inArray(id, productLines) > -1)
        jQuery(this).addClass('checked')
    })
  }

  if (galleryFilter.watercolor) {
    jQuery('.products .filter .watercolors > li a').each(function (index) {
      var id = jQuery(this).attr('id')
      var watercolors = galleryFilter.watercolor.split(',')

      if (jQuery.inArray(id, watercolors) > -1) jQuery(this).addClass('checked')
    })
  }

  if (galleryFilter.finishType) {
    jQuery('.products .filter .finish-types > li a').each(function (index) {
      var id = jQuery(this).attr('id')
      var finishTypes = galleryFilter.finishType.split(',')

      if (jQuery.inArray(id, finishTypes) > -1) jQuery(this).addClass('checked')
    })
  }

  galleryFilter.search = galleryFilter.search ?? ''
}

function getProductFilterValues() {
  galleryFilter.productLine = ''
  jQuery('.products .filter .product-lines > li a.checked').each(function (
    index
  ) {
    var id = jQuery(this).attr('id')
    if (id > 0) galleryFilter.productLine += id + ','
  })

  galleryFilter.productLine = galleryFilter.productLine.substring(
    0,
    galleryFilter.productLine.length - 1
  )

  if (jQuery('#productLine').val())
    galleryFilter.productLine = jQuery('#productLine').val()

  galleryFilter.watercolor = ''
  jQuery('.products .filter .watercolors > li a.checked').each(function (
    index
  ) {
    var id = jQuery(this).attr('id')
    if (id > 0) galleryFilter.watercolor += id + ','
  })
  galleryFilter.watercolor = galleryFilter.watercolor.substring(
    0,
    galleryFilter.watercolor.length - 1
  )

  galleryFilter.finishType = ''
  jQuery('.products .filter .finish-types > li a.checked').each(function (
    index
  ) {
    var id = jQuery(this).attr('id')
    if (id > 0) galleryFilter.finishType += id + ','
  })
  galleryFilter.finishType = galleryFilter.finishType.substring(
    0,
    galleryFilter.finishType.length - 1
  )

  var galleryFilterCookie = Object.assign({}, galleryFilter)

  if (galleryFilterCookie.productLine && jQuery('#productLine').val())
    galleryFilterCookie.productLine = ''

  if (jQuery.cookie)
    jQuery.cookie('galleryFilter', galleryFilterCookie, {
      expires: 30,
      path: '/'
    })
}

function productFilter() {
  getProductFilterValues()
  jQuery('.products #no-more-results').hide()

  productGalleryPage = 1
  productGalleryLastPage = false
  var parameters =
    '&productLine=' +
      galleryFilter.productLine +
      '&watercolor=' +
      galleryFilter.watercolor +
      '&finishType=' +
      galleryFilter.finishType +
      '&search=' +
      galleryFilter?.search ?? ''

  console.log(parameters)
  jQuery
    .get('/products/list?' + parameters, function (data) {
      jQuery('.products .grid').html('')
      jQuery('.products #keep-scrolling').show()

      if (data.length > 0) {
        jQuery.each(data, function (index, product) {
          appendProductToGallery(product)
        })
      } else {
        jQuery('.products #no-more-results').hide()
        jQuery('.products #keep-scrolling').hide()
        jQuery('.products .grid').html(
          '<div class="separator"></div><p class="text-center">Sorry, no results... try changing a filter to see some awesome pool finishes!</p>'
        )
      }
    })
    .always(function () {
      setupAddToFavorites()
    })
}
